"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SUBTYPE_METAMASK = exports.SUBTYPE_LEDGER = exports.SUBTYPE_TREZOR = exports.SUBTYPE_ETHERS = exports.SUBTYPE_GENERIC = exports.TYPE_GENERIC = exports.TYPE_HARDWARE = exports.TYPE_SOFTWARE = void 0;
var TYPE_SOFTWARE = 'software';
exports.TYPE_SOFTWARE = TYPE_SOFTWARE;
var TYPE_HARDWARE = 'hardware';
exports.TYPE_HARDWARE = TYPE_HARDWARE;
var TYPE_GENERIC = 'generic';
/*
 * Wallet subtypes
 */

exports.TYPE_GENERIC = TYPE_GENERIC;
var SUBTYPE_GENERIC = 'generic';
exports.SUBTYPE_GENERIC = SUBTYPE_GENERIC;
var SUBTYPE_ETHERS = 'ethers';
exports.SUBTYPE_ETHERS = SUBTYPE_ETHERS;
var SUBTYPE_TREZOR = 'trezor';
exports.SUBTYPE_TREZOR = SUBTYPE_TREZOR;
var SUBTYPE_LEDGER = 'ledger';
exports.SUBTYPE_LEDGER = SUBTYPE_LEDGER;
var SUBTYPE_METAMASK = 'metamask';
exports.SUBTYPE_METAMASK = SUBTYPE_METAMASK;
var walletTypes = {
  TYPE_GENERIC: TYPE_GENERIC,
  TYPE_SOFTWARE: TYPE_SOFTWARE,
  TYPE_HARDWARE: TYPE_HARDWARE,
  SUBTYPE_GENERIC: SUBTYPE_GENERIC,
  SUBTYPE_ETHERS: SUBTYPE_ETHERS,
  SUBTYPE_TREZOR: SUBTYPE_TREZOR,
  SUBTYPE_LEDGER: SUBTYPE_LEDGER,
  SUBTYPE_METAMASK: SUBTYPE_METAMASK
};
var _default = walletTypes;
exports.default = _default;